import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_garden_all: FaireCategoryEntity = {
  token: "cat_garden-all",
  type: "category",
  name: "All garden & outdoor",
  level: 3,
  parentToken: "cat_home-decor-garden",
  href: "/category/home-decor/garden-outdoor",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
